import styled from 'styled-components';
import color from 'tinycolor2';

export const Name = styled.span`
  margin-left: 15px;
`;

export const RowContent = styled.div`
  display: flex;
  align-items: center;
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  justify-items: flex-end;
  text-align: right;
  color: ${(props) => props.theme['autoComplete.item.subText.color']};
  font-size: 13px;
  line-height: 19px;
  padding-right: 4px;
`;

export const TeamIcon = styled.span`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${(props) => color(props.theme['color.primary']).setAlpha(0.2).toString()};
  color: ${(props) => props.theme['color.primary']};
`;
